<app-top-bar></app-top-bar>
<app-nav-bar></app-nav-bar>
<div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper  p-0">
        <div class="content-header row">
        </div>
        <div class="content-body">
            <router-outlet></router-outlet>        
        </div>
    </div>
</div>
<ngx-ui-loader
[fgsColor] = "'#059669'"
[fgsSize] = "30"
[fgsType] = "SPINNER.circle"
[hasProgressBar] = false
></ngx-ui-loader>